"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOfflineDirectSigner = isOfflineDirectSigner;
function isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
//# sourceMappingURL=signer.js.map